module.exports = __webpack_public_path__ + "static/media/marche.97afe746.jpg";